module.exports = __webpack_public_path__ + "static/media/10-sjeldan.a79d3ff8.mp3";